const config = {
    apiUrl: process.env.VUE_APP_API_URL,
    BaseUrl: process.env.VUE_APP_BASE_URL

}
export default config;


